import { DataBlockTypeDto, QueryFactory } from '@lmt/shared-types';
import { useCallback, useMemo } from 'react';
import type { Query, QueryKey } from '@tanstack/query-core';
import type { DefaultError } from '@tanstack/query-core';

export function useEnabledDataBlockTypes() {
  const { data: dataBlockTypes } = QueryFactory.DataBlockTypeQuery.useGetQuery({
    select: useCallback((data: DataBlockTypeDto[]) => {
      return data?.filter((z) => !z.isDeleted);
    }, []),
    throwOnError: defaultThrowOnError,
  });

  return dataBlockTypes ?? [];
}

export function useDataBlockType(dataBlockTypeId?: number) {
  const dataBlockTypes = useEnabledDataBlockTypes();

  return useMemo(() => {
    return dataBlockTypes?.find((type) => type.id === dataBlockTypeId);
  }, [dataBlockTypes, dataBlockTypeId]);
}
export const defaultThrowOnError = <
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  _error: TError,
  query: Query<TQueryFnData, TError, TData, TQueryKey>,
) => typeof query.state.data === 'undefined';
